import * as actionTypes from "../actions/actionTypes";

const initState = {
    messageLoading: false,
    messages: null,
    error: null,
    // all dealer :
    allUsersLoading: false,
    allUsers: null,
};

const initGetMessages = (state, action) => {
    return {
        ...state,
        messageLoading: action.messageLoading
    }
};

const successGetMessages = (state, action) => {
    return {
        ...state,
        messageLoading: action.messageLoading,
        messages: action.messages
    }
};

const failGetMessages = (state, action) => {
    return {
        ...state,
        messageLoading: action.messageLoading,
        error: action.error
    }
};

//####################################### All Users :

const initAllUsers = (state, action) => {
    return {
        ...state,
        allUsersLoading: action.allUsersLoading,
        error: action.error
    }
};

const successAllUsers = (state, action) => {
    return {
        ...state,
        allUsersLoading: action.allUsersLoading,
        allUsers: action.allUsers
    }
};

const failAllUsers = (state, action) => {
    return {
        ...state,
        allUsersLoading: action.allUsersLoading,
        error: action.error
    }
};

const Reducer = (state = initState, action) => {
    switch (action.type) {
        case actionTypes.INIT_Get_Messages: return initGetMessages(state, action)
        case actionTypes.SUCCESS_Get_Messages: return successGetMessages(state, action)
        case actionTypes.FAIL_Get_Messages: return failGetMessages(state, action)
        case actionTypes.INIT_ALL_USERS: return initAllUsers(state, action)
        case actionTypes.SUCCESS_ALL_USERS: return successAllUsers(state, action)
        case actionTypes.FAIL_ALL_USERS: return failAllUsers(state, action)
        default: return { ...state }
    }
};

export default Reducer;